import React, { useState, useEffect } from "react";

import { string, func } from "prop-types";
import { filtersShape } from "../prop-types.js";

import useMatchMedia from "../../../../../Common/js/common/useMatchMedia.js";

import SelectInput from "../../Form/SelectInput.jsx";

import cx from "classnames";
import * as R from "ramda";

const propTypes = {
  filters: filtersShape,
  activeFilter: string,
  onChange: func,
};

const CardSliderFilters = (props) => {
  const { filters, activeFilter, onChange } = props;

  const [value, setValue] = useState(activeFilter);

  // matches _breakpoints.scss
  const isDesktop = useMatchMedia("(min-width: 681px)");

  useEffect(() => {
    const selectedFilter = R.find(R.propEq("text", activeFilter))(filters);
    setValue(selectedFilter.value);
  }, [activeFilter, filters]);

  const handleFilterSelect = (e) => {
    const value = e.target.value;

    const selectedFilter = R.find(R.propEq("value", value))(filters);
    onChange(selectedFilter);
  };

  return (
    <div className="card-slider-filters">
      {isDesktop ? (
        filters.map((filter, idx) => (
          <button
            key={idx}
            type="button"
            className={cx("btn btn--secondary", "card-slider-filters__filter", {
              active: filter.text === activeFilter,
            })}
            onClick={() => onChange(filter)}
          >
            {filter.text}
          </button>
        ))
      ) : (
        <SelectInput
          name="framework-select"
          label=""
          options={filters}
          onChange={handleFilterSelect}
          value={value}
        />
      )}
    </div>
  );
};

CardSliderFilters.propTypes = propTypes;

export default CardSliderFilters;
